import { createRoot } from 'react-dom/client';
import { AppProviders } from '@/app/providers';
import App from '@/app/App';
import { initSentry } from '@/lib/sentry';
import { captureOAuthRedirectResult } from '@/lib/socialOAuthRedirect';
import { relayOAuthResultAndClose } from '@/lib/socialOAuthTab';
import './styles/globals.css';

// If this is a connect tab landing back from the provider, hand the result to
// the app tab and close, rather than booting a second copy of the app in it.
if (!relayOAuthResultAndClose()) {
  // Otherwise the connect ran in this tab — the new tab was blocked, or this
  // one has no opener to relay to. Read the result off the URL before anything
  // renders: the router rewrites `/app` → `/app/dashboard` and drops the query
  // long before an effect could see it. `useOAuthRedirectResult` consumes it.
  captureOAuthRedirectResult();

  initSentry();

  const container = document.getElementById('root')!;
  createRoot(container).render(
    <AppProviders>
      <App />
    </AppProviders>
  );
}
